import { ConsentState, JobSubmitResult, MyBoardProfile, MyJobRecords, RECORDS_NOTICE_VERSION, RecordsDeleted, } from "@gigsync/protocol";
import { HttpMethod } from "../http.js";
import { ApiClient, ApiPath, HttpError } from "../net/api.js";
/** The routes of workers/api for job records (ADR 0038). */
export const RecordsPath = {
    consent: "/v1/consent",
    jobs: "/v1/jobs/records",
    status: "/status",
    payments: "/payments",
    stars: "/stars",
    mine: "/v1/jobs/records/mine",
    myRecords: "/v1/me/records",
};
const SLASH = "/";
const NOT_FOUND = 404;
/** The same call, with "not there" as undefined instead of an error. */
async function orMissing(call) {
    try {
        return await call();
    }
    catch (err) {
        if (err instanceof HttpError && err.status === NOT_FOUND)
            return undefined;
        throw err;
    }
}
/** ApiClient with the job record calls: what a phone sends about its jobs, the consent, the export and deletion. */
export class RecordsClient extends ApiClient {
    job(engagement, leaf) {
        return `${RecordsPath.jobs}${SLASH}${engagement}${leaf}`;
    }
    async submitJob(submit) {
        return JobSubmitResult.parse(await this.call(HttpMethod.post, RecordsPath.jobs, submit));
    }
    async reportStatus(engagement, change) {
        await this.call(HttpMethod.post, this.job(engagement, RecordsPath.status), change);
    }
    async reportPayment(engagement, report) {
        await this.call(HttpMethod.post, this.job(engagement, RecordsPath.payments), report);
    }
    async reportStars(engagement, report) {
        await this.call(HttpMethod.put, this.job(engagement, RecordsPath.stars), report);
    }
    consent() {
        return orMissing(async () => ConsentState.parse(await this.call(HttpMethod.get, RecordsPath.consent)));
    }
    async acceptConsent() {
        const body = { notice_version: RECORDS_NOTICE_VERSION };
        return ConsentState.parse(await this.call(HttpMethod.put, RecordsPath.consent, body));
    }
    async deleteRecords() {
        return RecordsDeleted.parse(await this.call(HttpMethod.delete, RecordsPath.myRecords));
    }
    async myJobRecords(page = {}) {
        const query = new URLSearchParams(Object.entries(page)
            .filter(([, v]) => v !== undefined)
            .map(([k, v]) => [k, String(v)]));
        return MyJobRecords.parse(await this.call(HttpMethod.get, `${RecordsPath.mine}?${query}`));
    }
    ownCard() {
        return orMissing(async () => MyBoardProfile.parse(await this.call(HttpMethod.get, ApiPath.boardProfile)));
    }
}
//# sourceMappingURL=client.js.map